
// メッセージをポップアップ表示する。
function dispMessage(message){
  alert(message);
}

// 日付をYYYY年MM月DD日に変換する
function dateFormat(date) {
  let datefmt = new Date(date);
  let year = datefmt.getFullYear();
  let month = datefmt.getMonth() + 1;
  let day = datefmt.getDate();
  return year + '年' + month + '月' + day + '日';
}

// 金額を\9,999,999形式に変換する
function priceToLocaleString(price) {
  return `¥ ${price.toLocaleString()}`
}

async function doLogin(){
  // ボタン制御
  let loginBtn = document.getElementById('loginForm');
  loginBtn.disabled = true;

  clearPointCache();
  
  let loginId = document.querySelector('#login_id').value;
  let password = document.querySelector('#login_password').value;

  if (!loginId || !password) {
    setLoginErrorMsg();
    loginBtn.disabled = false;
    return false;
  }
  
  if(!validateEmail(loginId)){
    setEmailErrorMsg();
    loginBtn.disabled = false;
    return false;
  }

  let redirectUrl = getRedirectUrl();
  let requestUrl = APP_PROXY_PATH + '/member/login';
  let bodyData = {
    loginId : loginId,
    loginPassword : password,
    redirectUrl : redirectUrl
  };
  let loginRequestSetting = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(bodyData)
  };
  
  await fetch(requestUrl, loginRequestSetting)
  .then((response) => {
    if (!response.ok) {
      throw new Error();
    }
    return response.json();
  }).then((data) => {
    if(data.error_flg == true){
      if(data.oversea_flg == true){
        setOverSeaErrorMsg();
      } else if(data.lock_flg == true) {
        setAccountLockErrorMsg();
      } else {
        setLoginErrorMsg();
      }
      
      loginBtn.disabled = false;
    } else {
      location.href = data.redirect_url;
    }
  })
  .catch((error) => {
    setLoginErrorMsg();
    loginBtn.disabled = false;
  });
}

function getRedirectUrl(){
  let url = new URL(window.location.href);
  let params = url.searchParams;
  let redirectUrl = '';

  if(params.get('checkout_url') != null){
    // GETパラメータがURLエンコード済みかチェック(2重エンコードを防ぐため)
    if(params.get('checkout_url').length == decodeURIComponent(params.get('checkout_url')).length){
      redirectUrl = encodeURIComponent(params.get('checkout_url'));
    } else {
      redirectUrl = params.get('checkout_url');
    }
  } else if(params.get('redirect_url') != null){
    // GETパラメータがURLエンコード済みかチェック(2重エンコードを防ぐため)
    if(params.get('redirect_url').length == decodeURIComponent(params.get('redirect_url')).length){
      redirectUrl = encodeURIComponent(params.get('redirect_url'));
    } else {
      redirectUrl = params.get('redirect_url');
    }
  } else if(params.get('return_url') != null){
    // GETパラメータがURLエンコード済みかチェック(2重エンコードを防ぐため)
    if(params.get('return_url').length == decodeURIComponent(params.get('return_url')).length){
      redirectUrl = encodeURIComponent(params.get('return_url'));
    } else {
      redirectUrl = params.get('return_url');
    }
  }

  return redirectUrl;
}

// ログイン画面でのエラーメッセージ・QAページへのリンク表示制御(海外在住)
function setOverSeaErrorMsg(){
  let oldErrorElem = document.querySelector('.customer-error');
  
  if(oldErrorElem != null){
    oldErrorElem.remove();
  }

  let newErrorElem = document.querySelector('#overSeaTemplate').content.cloneNode(true);
  document.getElementById('login-page-title').after(newErrorElem);
}

// ログイン画面でのエラーメッセージ・QAページへのリンク表示制御(メールアドレス形式チェックエラー)
function setEmailErrorMsg(){
  let oldErrorElem = document.querySelector('.customer-error');
  
  if(oldErrorElem != null){
    oldErrorElem.remove();
  }

  let newErrorElem = document.querySelector('#mailErrorTemplate').content.cloneNode(true);
  document.getElementById('login-page-title').after(newErrorElem);
}

// ログイン画面でのエラーメッセージ・QAページへのリンク表示制御(メールアドレス形式チェックエラー)
function setAccountLockErrorMsg(){
  let oldErrorElem = document.querySelector('.customer-error');
  
  if(oldErrorElem != null){
    oldErrorElem.remove();
  }

  let newErrorElem = document.querySelector('#accountLockTemplate').content.cloneNode(true);
  document.getElementById('login-page-title').after(newErrorElem);
}

// ログイン画面でのエラーメッセージ・QAページへのリンク表示制御(ログインエラー)
function setLoginErrorMsg(){
  let oldErrorElem = document.querySelector('.customer-error');
  let newErrorElem = document.querySelector('#loginErrorTemplate').content.cloneNode(true);

  let oldQaLinkElem = document.querySelector('.customer-link__fqa');
  let newQaLinkElem = document.querySelector('#qaLinkTemplate').content.cloneNode(true);
  
  if(oldErrorElem != null){
    oldErrorElem.remove();
  }

  if(oldQaLinkElem == null){
    document.getElementById('forgot-page-link').after(newQaLinkElem);
  }
  
  document.getElementById('login-page-title').after(newErrorElem);
}

// 注文から60分経過チェック
function checkOrderCancelPeriod(orderCreatedAtStr){
  var orderCreatedAt = Date.parse(orderCreatedAtStr);

  let diff = Date.now() - parseFloat(orderCreatedAt.toString())
  let period = 1000 * 60 * 60;
  if (diff > period) {
    return true;
  } else {
    return false;
  }
}

//SKUから商品情報取得
 async function getProductInfo(sku) {
 	let productInfo;

 	await fetch(window.Shopify.routes.root + 'products/' + sku + '.js', {
 		method: 'GET'
 	}).then(function(response) {
 		if (response.status != 200) {
 			throw new Error();
 		} else {
          return response.json();
 		}
 	}).then(function(data){
        productInfo = data;
        return;
    }).catch(function(response) {
 		return;
 	});

 	return productInfo;
 }
// 表示すべき画像のURLを取得
function getProductImageUrl(productInfo, sku_code){
  let sku = sku_code.replaceAll(" ","_");
  
  if(productInfo != null){
    for(let i=0;i < productInfo.variants.length;i++){
      if(productInfo.variants[i].sku === sku){
        if(productInfo.variants[i].featured_image != null){
          return productInfo.variants[i].featured_image.src;
        } else if(productInfo.featured_image != null) {
          return productInfo.featured_image;
        }
      }
    }
  }
  
  return NO_IMAGE_URL;
}

// URLパラメータから商品IDを取得
function getProductIdFromGetParam(){
  let url = new URL(window.location.href);
  let params = url.searchParams;
  return params.get('product_id');
}

// URLパラメータからSKUを取得
function getSkuFromGetParam(){
  let url = new URL(window.location.href);
  let params = url.searchParams;
  return params.get('sku');
}

// URLパラメータからposIdを取得
function getPosIdFromGetParam(){
  let url = new URL(window.location.href);
  let params = url.searchParams;
  return params.get('pos_id');
}

// URLパラメータからプロセスIDを取得
function getProcessIdFromGetParam(){
  let url = new URL(window.location.href);
  let params = url.searchParams;
  return params.get('process_id');
}

// 試着用トークン取得API実行
async function getFittingToken(jsonBody){
  let requestUrl = APP_PROXY_PATH + '/Fitting/token';
  let tokenGetSetting = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(jsonBody)
  };

  await fetch(requestUrl, tokenGetSetting)
  .then((response) => {
    if (!response.ok) {
      throw new Error();
    }
    return response.json();
  })
  .then((data) => {
    if(data.error_flg == true){
      dispMessage('システムエラーが発生しました。\nページを再読み込みしてください。解決しない場合には、三陽商会ECカスタマーサポートへお問い合わせください。');
      window.close();
    } else {
      if(getSkuFromGetParam() != null){
        postFittingRequestForm(data.token);
      } else {
        postFittingShopListForm(data.token);
      }
    }
  })
  .catch((error) => {
    console.log(error);
    dispMessage('システムエラーが発生しました。\nページを再読み込みしてください。解決しない場合には、三陽商会ECカスタマーサポートへお問い合わせください。');
    window.close();
  });
}

// トークン取得処理実行後/未ログイン時の試着可能店舗一覧画面への遷移処理
function postFittingShopListForm(tokenString){
  const form = document.querySelector('#fitting-shop-list-form');
  const productId = form.querySelector('#productId');
  const token = form.querySelector('#token');
  const processId = form.querySelector('#processId');

  form.action = CUSTOM_APP_DOMAIN + '/fitting/shoplist';
  productId.value = getProductIdFromGetParam();
  token.value = tokenString;
  processId.value = getProcessIdFromGetParam();

  form.submit();
}

// トークン取得処理実行後/店舗試着申込画面への遷移処理
function postFittingRequestForm(tokenString){
  const form = document.querySelector('#fitting-request-form');
  const sku = form.querySelector('#sku');
  const posId = form.querySelector('#posId');
  const token = form.querySelector('#token');
  const processId = form.querySelector('#processId');

  form.action = CUSTOM_APP_DOMAIN + '/fitting/request';
  sku.value = getSkuFromGetParam();
  posId.value = getPosIdFromGetParam();
  token.value = tokenString;
  processId.value = getProcessIdFromGetParam();

  form.submit();
}

// RFC準拠のメールアドレスかチェック
function validateEmail(email) {
  if (256 <= email.length) {
    return false;
  }

  const [local, domain] = email.split("@");

  if (!domain) {
    return false;
  }

  if (64 <= local.length) {
    return false;
  }

  if (255 <= domain.length) {
    return false;
  }

  if (local.match(/\.{2,}/)) {
    return false;
  }

  if (local.startsWith(".") || local.endsWith(".")) {
    return false;
  }

  if (
    local.startsWith("-") ||
    local.endsWith("-") ||
    domain.startsWith("-") ||
    domain.endsWith("-")
  ) {
    return false;
  }

  if (domain.match(/^\d+$/)) {
    return false;
  }

  if (local.match(/[ (),:;<>@[\]]/) || domain.match(/[ (),:;<>@[\]]/)) {
    return false;
  }

  return true;
}

